import once from 'transmute/once';
import { loadStripe } from 'stripe-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLangLocale from 'I18n/utils/getLangLocale';
import { jsx as _jsx } from "react/jsx-runtime";
export const buildStripePromise = (publishableKey, isBYOSPortal, connectedAccountId) => {
  let options = {
    betas: ['us_bank_account_beta_2', 'deferred_intent_pe_optional_amount_beta_0'],
    locale: getLangLocale()
  };
  if (isBYOSPortal && connectedAccountId) {
    options = Object.assign({}, options, {
      stripeAccount: connectedAccountId
    });
  }
  return loadStripe(publishableKey, options);
};
export const getStripePromise = once(buildStripePromise);
export const getStripeErrorMessageFromErrorCodeForCard = error => {
  // Stripe testing doc reference for cards:
  // https://stripe.com/docs/testing?numbers-or-method-or-token=card-numbers
  switch (error.code) {
    case 'card_declined':
      if (error.decline_code === 'live_mode_test_card') {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.errorAlert.payment.cardDeclinedTestCard"
        });
      }
      if (error.decline_code === 'insufficient_funds') {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.errorAlert.payment.cardDeclinedInsufficientFunds"
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorAlert.payment.cardDeclined"
      });
    case 'expired_card':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorAlert.payment.cardExpired"
      });
    case 'incorrect_zip':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorAlert.payment.incorrectZip"
      });
    case 'incorrect_cvc':
    case 'invalid_cvc':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorAlert.payment.incorrectCVC"
      });
    default:
      return null;
  }
};
export const getStripeErrorMessageFromErrorCodeForACH = error => {
  switch (error.code) {
    case 'account_number_invalid':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorAlert.payment.achAccountNumberInvalid"
      });
    case 'routing_number_invalid':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorAlert.payment.achRoutingNumberInvalid"
      });
    case 'payment_method_invalid_parameter':
      if (error.param === 'payment_method_data[us_bank_account][routing_number]') {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.errorAlert.payment.achRoutingNumberInvalid"
        });
      } else if (error.param === 'payment_method_data[us_bank_account][account_number]') {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.errorAlert.payment.achAccountNumberInvalid"
        });
      }
      return null;
    case 'payment_method_invalid_parameter_testmode':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorAlert.payment.achAccountNumberInvalidTestMode"
      });
    case 'payment_intent_payment_attempt_failed':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorAlert.payment.achPaymentAttemptFailed"
      });
    default:
      return null;
  }
};